import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import RunningDocumentTaskRow from './components/RunningDocumentTaskRow'

interface Props {
  tasks: RunningTask[]
}

// Running document generation/preview tasks with their progress (shown in the document
// manager footers)
const RunningDocumentTasks = ({ tasks }: Props): ReactElement | null => {
  if (!tasks.length) return null

  return (
    <Stack spacing={0.75} data-cy="running-document-tasks">
      {tasks.map(task => (
        <RunningDocumentTaskRow key={task.task_id} task={task} />
      ))}
    </Stack>
  )
}

export default RunningDocumentTasks
